import React from 'react';
import Form from '../../components/Form/index';
import { useDispatch, useSelector } from 'react-redux';
import { createCalendar } from '../../services/create_calendar/actions';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { SuccessMessage, InfoMessage } from './../../components/Messages/index';
import moment from 'moment';
const CreateCalendar = () => {
    const dispatch = useDispatch();
    const creationData = useSelector(state => state.calendarCreationData);
    const { name, sellerEmail, sentAt } = creationData || {};
    const handleSubmit = (data) => {
        dispatch(createCalendar(data));
    };
    return (
        <div className='start-page'>
            <div className='start-page__form'>
                <h3 className='page-title'>Welcome - Start Scheduling an Appointment&nbsp;&nbsp; <DateRangeIcon /></h3>
                <InfoMessage
                    title='The Surplus Scheduler offers a convenient way to schedule appointments.'
                    title2=' Enter your email address and a name for the appointment.
                    Click “Create Appointment” and a link will be sent to you where you can indicate your availability.'
                    iconSize={30}
                />
               
                <Form onSubmit={handleSubmit} />

                {sentAt && (
                    <div className="event-created-msg-style">
                    <SuccessMessage
                        iconSize={30}
                        title={(
                            <span >
                                <b>{name}</b>
                                &nbsp;appointment created successfully. Check your email for a link to your appointment.
              </span>
                        )}
                        />
                    </div>
                )}
            </div>
            {sentAt && (
                <div className='start-page__log'>
                    <InfoMessage
                        title={(
                            <span>
                                Email Notification with <b>{name}</b> appointment link sent to {sellerEmail} on {moment(sentAt).format('MM/DD/YYYY HH:mm A')}.
              </span>
                        )}
                        logger
                    />
                </div>
            )}
        </div>
    );
}

export default CreateCalendar;